import { useInView } from "react-intersection-observer";

export const HeadingAndCopy = ({ heading, paragraph, className }) => {
  const [slideUpRef, isInView] = useInView({ triggerOnce: true });

  return (
    <div
      className={`tw-flex tw-flex-col tw-gap-8 tw-items-center tw-text-center animation ${
        isInView ? "slide-up" : ""
      } ${className}`}
      ref={slideUpRef}
    >
      <h2 className="heading2">{heading}</h2>
      <div dangerouslySetInnerHTML={{ __html: paragraph }} />
    </div>
  );
};
